import { createActionType } from '../core';
import { NAME } from './constants';

export const GET_AUDIT_LOGS = createActionType(`${NAME}/GET_AUDIT_LOGS`);
export const GET_AUDIT_ADMINS = createActionType(`${NAME}/GET_AUDIT_ADMINS`);
